import React, { useState, useEffect, useRef } from "react";
import { Typography, Chip, Box } from "@mui/material";
import Button from "@mui/material/Button";

import { motion } from "framer-motion";

import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import ConfirmarMudarPlano from "../../components/ConfirmarMudarPlano";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";
import HomeIcon from '@mui/icons-material/Home';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Breadcrumbs, Link } from "@mui/material";

const cardVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.08, duration: 0.4, ease: "easeOut" },
    }),
};

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

// status: "sim" = incluso, "limitado" = incluso com restrição, "nao" = não incluso
const planosChip = {
    "Essencial": [
        { label: "Faturamento da PJ até: R$ 20.000/mês", status: "sim" },
        { label: "Composição societária: até 1 sócio", status: "sim" },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", status: "sim" },
        { label: "Obrigações fiscais/contábeis: dentro do Simples Nacional", status: "sim" },
        { label: "Certificado digital incluso: apenas no plano anual", status: "sim" },
        { label: "Regime tributário: Simples Nacional", status: "sim" },
        { label: "IRPF sob demanda: até 1 sócio incluso", status: "limitado" },
        { label: "Emissão via Clarea Fácil: até 3 NF/mês", status: "limitado" },
        { label: "Apenas pró-labore do sócio", status: "limitado" },
        { label: "Emissões/mês feitas pela equipe Clarea", status: "nao" },
        { label: "Folha de pagamento de colaboradores", status: "nao" },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", status: "nao" },
    ],
    "Profissional": [
        { label: "Faturamento da PJ até: R$ 60.000/mês", status: "sim" },
        { label: "Composição societária: até 2 sócios", status: "sim" },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", status: "sim" },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", status: "sim" },
        { label: "Certificado digital incluso: apenas no plano anual", status: "sim" },
        { label: "Regime tributário: Simples Nacional", status: "sim" },
        { label: "IRPF sob demanda: até 2 sócios inclusos", status: "sim" },
        { label: "Emissão via Clarea Fácil: ilimitada", status: "sim" },
        { label: "Pró-labore dos sócios", status: "sim" },
        { label: "Emissões/mês feitas pela equipe Clarea: até 10", status: "sim" },
        { label: "Folha de pagamento até 2 colaboradores", status: "sim" },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", status: "nao" },
    ],
    "Premium": [
        { label: "Faturamento da PJ até: R$ 150.000/mês", status: "sim" },
        { label: "Composição societária: até 3 sócios", status: "sim" },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", status: "sim" },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", status: "sim" },
        { label: "Certificado digital incluso: apenas no plano anual", status: "sim" },
        { label: "Regime tributário: Simples Nacional", status: "sim" },
        { label: "IRPF sob demanda: até 3 sócios inclusos", status: "sim" },
        { label: "Emissão via Clarea Fácil: ilimitada", status: "sim" },
        { label: "Pró-labore dos sócios", status: "sim" },
        { label: "Emissões/mês feitas pela equipe Clarea: até 20", status: "sim" },
        { label: "Folha de pagamento: até 3 colaboradores", status: "sim" },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", status: "nao" },
    ],
    "Expert": [
        { label: "Faturamento da PJ até: R$ 400.000/mês (R$ 4,8 milhões/ano – teto do Simples Nacional)", status: "sim" },
        { label: "Composição societária: até 3 sócios", status: "sim" },
        { label: "Atuação junto a planos de saúde (sob demanda): envio de NF por e-mail e anexos em portais", status: "sim" },
        { label: "Obrigações fiscais/contábeis: completas dentro do Simples Nacional", status: "sim" },
        { label: "Certificado digital incluso: apenas no plano anual", status: "sim" },
        { label: "Regime tributário: Simples Nacional", status: "sim" },
        { label: "IRPF sob demanda: até 3 sócios inclusos", status: "sim" },
        { label: "Emissão via Clarea Fácil: ilimitada", status: "sim" },
        { label: "Pró-labore dos sócios", status: "sim" },
        { label: "Emissões/mês feitas pela equipe Clarea: até 30", status: "sim" },
        { label: "Folha de pagamento: até 5 colaboradores", status: "sim" },
        { label: "50% de desconto em planejamento patrimonial para até 3 sócios (somente no plano anual)", status: "sim" },
    ],
    "Plus Personalizado": [
        { label: "Estrutura adaptada a regimes Lucro Presumido ou Lucro Real", status: "sim" },
        { label: "Planejamento tributário e societário completo", status: "sim" },
        { label: "Consultoria contábil e estratégica personalizada", status: "sim" },
        { label: "Suporte dedicado e reuniões sob demanda", status: "sim" },
    ]
}

const moeda = (valor) => (Number(valor) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const ItemBeneficio = ({ label, status, escuro }) => {
    const icones = {
        sim: <CheckCircleRoundedIcon sx={{ fontSize: 16, color: escuro ? "#4ade80" : "#16a34a" }} />,
        limitado: <RemoveCircleOutlineRoundedIcon sx={{ fontSize: 16, color: escuro ? "#fcd34d" : "#d97706" }} />,
        nao: <CancelOutlinedIcon sx={{ fontSize: 16, color: escuro ? "#64748b" : "#d1d5db" }} />,
    };
    const corTexto = status === "nao"
        ? (escuro ? "#64748b" : "#9ca3af")
        : (escuro ? "#e2e8f0" : "#374151");

    return (
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <Box sx={{ display: "flex", mt: "1px", flexShrink: 0 }}>{icones[status] || icones.sim}</Box>
            <Typography sx={{ fontSize: 12, color: corTexto, lineHeight: 1.45, textDecoration: status === "nao" ? "line-through" : "none" }}>
                {label}
            </Typography>
        </Box>
    );
};


const MudarPlano = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openConfirmarMudarPlano, setOpenConfirmarMudarPlano] = useState(false);
    const [idPlanoEscolhido, setIdPlanoEscolhido] = useState(null);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);


    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    const [objPlanos, setObjPlanos] = useState([]);

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/mudarPlano/getPlanos/${user?.plano?.idPlano}`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                const data = response.data.data;
                const updatedData = data.map(plan => {
                    plan.chips = planosChip[plan.nome] || [];
                    return plan;
                });
                setObjPlanos(updatedData);
            }
        };

        if (user?.plano?.idPlano) {
            getPlanos();
        }
    }, [user?.plano?.idPlano]);


    const handleChangePlan = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/mudarPlano/mudarPlano`, { idPlanoEscolhido }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            if (response.data.status === 200) {
                setOpenSnackbarSuccess(true);
            } else {
                setOpenSnackbarError(true);
            }
        } catch (error) {
            console.error("Erro ao mudar plano:", error);
            setOpenSnackbarError(true);
        }
        fetchUser();
    }

    const faturasVencidas = user?.faturas?.vencidas?.length || 0;

    // Carrossel (apenas mobile): no desktop o container é uma grade e não rola
    const carrosselRef = useRef(null);
    const [slideAtivo, setSlideAtivo] = useState(0);

    const handleScrollCarrossel = () => {
        const container = carrosselRef.current;
        const primeiro = container?.firstElementChild;
        if (!primeiro) return;
        const passo = primeiro.offsetWidth + parseFloat(getComputedStyle(container).columnGap || 0);
        setSlideAtivo(Math.round(container.scrollLeft / passo));
    };

    const irParaSlide = (index) => {
        const slide = carrosselRef.current?.children[index];
        if (!slide) return;
        carrosselRef.current.scrollTo({ left: slide.offsetLeft - carrosselRef.current.offsetLeft, behavior: "smooth" });
    };

    // Abre o carrossel já no plano atual
    useEffect(() => {
        const indexAtual = objPlanos.findIndex((plan) => plan?.idPlano === user?.plano?.idPlano);
        const container = carrosselRef.current;
        const slide = container?.children[indexAtual];
        if (indexAtual > 0 && slide && container.scrollWidth > container.clientWidth) {
            container.scrollTo({ left: slide.offsetLeft - container.offsetLeft });
            setSlideAtivo(indexAtual);
        }
    }, [objPlanos, user?.plano?.idPlano]);

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard/Assinatura")}
                            >
                                <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Assinatura & Cobranças
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <PublishedWithChangesIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Mudar Plano
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Mudar Plano
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Compare os planos disponíveis e escolha o que melhor atende ao momento da sua empresa.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                        {user?.plano?.nome && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, backgroundColor: "#f3f4f6", borderRadius: "10px", px: 1.5, py: 1 }}>
                                <Box sx={{ width: 32, height: 32, borderRadius: "8px", backgroundColor: "#0b243d", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <WorkspacePremiumIcon sx={{ color: "#ffc845", fontSize: 18 }} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Seu plano atual</Typography>
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{user.plano.nome}</Typography>
                                </Box>
                            </Box>
                        )}
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard/Assinatura")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                    </Box>
                </Box>

                {faturasVencidas > 0 && (
                    <Box
                        sx={{
                            mt: 2,
                            display: "flex",
                            alignItems: { xs: "flex-start", sm: "center" },
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            gap: 1.5,
                            backgroundColor: "#fef3c7",
                            border: "1px solid #fde68a",
                            borderRadius: "12px",
                            px: 2,
                            py: 1.5,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#b45309" }}>
                            <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                Você tem faturas vencidas. Regularize sua situação para poder realizar a troca de plano.
                            </Typography>
                        </Box>
                        <Button
                            onClick={() => navigate("../Dashboard/Faturas/Pendentes")}
                            sx={{ flexShrink: 0, textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#f5b82e" } }}
                        >
                            Ver faturas
                        </Button>
                    </Box>
                )}

                <Box
                    ref={carrosselRef}
                    onScroll={handleScrollCarrossel}
                    sx={{
                        mt: 2,
                        display: { xs: "flex", sm: "grid" },
                        gridTemplateColumns: { sm: "repeat(2, 1fr)", lg: "repeat(auto-fit, minmax(240px, 1fr))" },
                        gap: 2,
                        alignItems: "stretch",
                        // Mobile: carrossel horizontal com snap, ocupando a largura da tela
                        overflowX: { xs: "auto", sm: "visible" },
                        scrollSnapType: { xs: "x mandatory", sm: "none" },
                        mx: { xs: -2, sm: 0 },
                        px: { xs: 2, sm: 0 },
                        scrollPaddingInline: { xs: "16px" },
                        pb: { xs: 1, sm: 0 },
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    {objPlanos.map((plan, i) => {
                        const isAtual = plan?.idPlano === user?.plano?.idPlano;
                        const isSobConsulta = plan.nome === "Plus Personalizado";
                        const valorAntigo = Number(plan?.valorAntigoMensal);
                        const desconto = Number(plan?.descontoMensal);

                        return (
                            <Box
                                key={plan.idPlano ?? i}
                                sx={{ display: "flex", flex: { xs: "0 0 85%", sm: "initial" }, scrollSnapAlign: { xs: "center", sm: "none" } }}
                            >
                            <motion.div
                                custom={i}
                                variants={cardVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                                style={{ display: "flex", width: "100%" }}
                            >
                                <Box
                                    sx={{
                                        ...cardSx,
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        position: "relative",
                                        backgroundColor: isAtual ? "#0b243d" : "#fff",
                                        border: isAtual ? "none" : "1px solid #e5e7eb",
                                        color: isAtual ? "#fff" : "#111827",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                        "&:hover": { transform: "translateY(-2px)", boxShadow: "0 8px 20px rgba(0,0,0,0.08)" },
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, minHeight: 22 }}>
                                        {isAtual ? (
                                            <Chip
                                                label="Plano atual"
                                                size="small"
                                                sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                            />
                                        ) : <span />}
                                        {desconto > 0 && (
                                            <Chip
                                                label={`${parseInt(desconto)}% OFF`}
                                                size="small"
                                                sx={{ backgroundColor: isAtual ? "rgba(34, 197, 94, 0.15)" : "#dcfce7", color: isAtual ? "#4ade80" : "#15803d", fontWeight: 700, fontSize: 10, height: 20 }}
                                            />
                                        )}
                                    </Box>

                                    <Typography sx={{ mt: 1.5, fontSize: 20, fontWeight: 700 }}>{plan.nome}</Typography>
                                    <Typography sx={{ mt: 0.5, fontSize: 12, color: isAtual ? "#cbd5e1" : "#6b7280", minHeight: 36 }}>
                                        {plan.descricao}
                                    </Typography>

                                    <Box sx={{ mt: 2, minHeight: 56 }}>
                                        {isSobConsulta ? (
                                            <Typography sx={{ fontSize: 24, fontWeight: 700, color: isAtual ? "#ffc845" : "#111827" }}>Sob consulta</Typography>
                                        ) : (
                                            <>
                                                {valorAntigo > 0 && (
                                                    <Typography sx={{ fontSize: 12, color: isAtual ? "#94a3b8" : "#9ca3af", textDecoration: "line-through" }}>
                                                        {moeda(valorAntigo)}
                                                    </Typography>
                                                )}
                                                <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
                                                    <Typography sx={{ fontSize: 26, fontWeight: 700, color: isAtual ? "#ffc845" : "#111827", lineHeight: 1.2 }}>
                                                        {moeda(plan.valorNovoMensal)}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 12, color: isAtual ? "#94a3b8" : "#6b7280" }}>/mês</Typography>
                                                </Box>
                                            </>
                                        )}
                                    </Box>

                                    <Box sx={{ mt: 2 }}>
                                        {isAtual ? (
                                            <Button fullWidth disabled sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, borderRadius: "8px", py: 1, "&.Mui-disabled": { color: "#94a3b8", backgroundColor: "rgba(255, 255, 255, 0.06)" } }}>
                                                Você está neste plano
                                            </Button>
                                        ) : isSobConsulta ? (
                                            <Button
                                                fullWidth
                                                startIcon={<WhatsAppIcon />}
                                                onClick={() => {
                                                    window.open(gerarLinkWhatsApp("Olá, tenho interesse no plano *Plus Personalizado* (Sob Consulta). Poderia me enviar mais informações?"), '_blank');
                                                }}
                                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#f3f4f6", borderRadius: "8px", py: 1, "&:hover": { backgroundColor: "#e5e7eb" } }}
                                            >
                                                Solicitar contato
                                            </Button>
                                        ) : (
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                startIcon={<SwapHorizIcon />}
                                                onClick={() => {
                                                    setIdPlanoEscolhido(plan.idPlano);
                                                    setOpenConfirmarMudarPlano(true);
                                                }}
                                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", py: 1, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                                            >
                                                Assinar plano
                                            </Button>
                                        )}
                                    </Box>

                                    <Box sx={{ mt: 2.5, pt: 2, borderTop: isAtual ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #f3f4f6", display: "flex", flexDirection: "column", gap: 1 }}>
                                        <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: isAtual ? "#94a3b8" : "#6b7280", mb: 0.5 }}>
                                            O que está incluso
                                        </Typography>
                                        {plan.chips.map((chip, idx) => (
                                            <ItemBeneficio key={idx} label={chip.label} status={chip.status} escuro={isAtual} />
                                        ))}
                                    </Box>
                                </Box>
                            </motion.div>
                            </Box>
                        );
                    })}
                </Box>

                {/* Indicadores do carrossel (apenas mobile) */}
                {objPlanos.length > 1 && (
                    <Box sx={{ mt: 1.5, display: { xs: "flex", sm: "none" }, alignItems: "center", justifyContent: "center", gap: 0.75 }}>
                        {objPlanos.map((plan, i) => (
                            <Box
                                key={plan.idPlano ?? i}
                                component="button"
                                type="button"
                                aria-label={`Ver plano ${plan.nome}`}
                                onClick={() => irParaSlide(i)}
                                sx={{
                                    width: slideAtivo === i ? 20 : 8,
                                    height: 8,
                                    p: 0,
                                    border: "none",
                                    borderRadius: 4,
                                    cursor: "pointer",
                                    backgroundColor: slideAtivo === i ? "#0b243d" : "#d1d5db",
                                    transition: "all 0.2s ease",
                                }}
                            />
                        ))}
                    </Box>
                )}

                {objPlanos.length > 0 && (
                    <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2.5, flexWrap: "wrap", justifyContent: "center" }}>
                        <ItemBeneficio label="Incluso" status="sim" />
                        <ItemBeneficio label="Incluso com limite" status="limitado" />
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CancelOutlinedIcon sx={{ fontSize: 16, color: "#d1d5db" }} />
                            <Typography sx={{ fontSize: 12, color: "#9ca3af" }}>Não incluso</Typography>
                        </Box>
                    </Box>
                )}
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ConfirmarMudarPlano
                openConfirmarMudarPlano={openConfirmarMudarPlano}
                setOpenConfirmarMudarPlano={setOpenConfirmarMudarPlano}
                handleChangePlan={handleChangePlan}
            />
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={"Plano alterado com sucesso!"} />
            <AlertError setOpenSnackbarError={setOpenSnackbarError} openSnackbarError={openSnackbarError} mensagem={"Não foi possível alterar o plano. Tente novamente mais tarde."} />
        </>
    )
}

export default MudarPlano;
